'use client';

import AppLink from './AppLink';
import GoogleOAuthButton from './GoogleOAuthButton';
import { usePathname } from 'next/navigation';
import { useLandingAccount, landingAccountType } from '../../lib/landingAccount';
import { DEFAULT_LOCALE, getSiteCopy, normalizeLocale } from '../../lib/siteI18n';

export default function PremiumSignupActions({ locale, billingInterval, ctaLocation, compareHref, sourceIntent, intent }) {
  const activeLocale = normalizeLocale(locale);
  const home = getSiteCopy(activeLocale).home;
  const account = useLandingAccount();
  const pathname = usePathname();
  const registered = account?.kind === 'registered';
  if (registered && account.isPremium !== false) return null;
  const interval = billingInterval === 'annual' ? 'annual' : 'monthly';
  const prefix = ctaLocation === 'hero' ? 'hero_premium' : ctaLocation === 'pseo_pricing' ? 'pseo_pricing_pro' : 'pricing_pro';
  const planIntent = `pro_${interval}`;
  const destination = new URLSearchParams({ premium: interval, lang: activeLocale,
    ...(intent === 'url_import' ? { intent } : {}), ...(sourceIntent ? { source_intent: sourceIntent } : {}) });
  const redirectPath = `/app/dashboard?${destination}`;
  const trackingParams = {
    landing_path: pathname || (activeLocale === DEFAULT_LOCALE ? '/' : `/${activeLocale}`),
    cta_location: ctaLocation,
    plan_intent: planIntent,
    billing_interval: interval,
    account_type: landingAccountType(account),
    offer_variant: `landing_${ctaLocation}`,
    ...(sourceIntent ? { source_intent: sourceIntent } : {}),
  };
  const signupParams = new URLSearchParams({
    from: 'landing',
    landing_locale: activeLocale,
    redirect_path: redirectPath.replace(/^\/app/, ''),
    auth_target: 'signup',
    auth_method: 'email',
    cta_id: `${prefix}_email_${interval}`,
    ...trackingParams,
  });

  return <div className="pricing-signup-container premium-signup-actions">
    {registered ? <AppLink href={redirectPath} className="premium-signup-button"
      data-analytics-event={`${prefix}_checkout_click`}
      data-analytics-cta-id={`${prefix}_checkout_${interval}`}
      data-analytics-cta-location={ctaLocation}
      data-analytics-account-type={landingAccountType(account)}
      data-analytics-offer-variant={`landing_${ctaLocation}`}
      data-analytics-plan-intent={planIntent}
      data-analytics-billing-interval={interval}>{home.premiumStart}</AppLink>
      : <GoogleOAuthButton locale={activeLocale} label={home.premiumGoogle}
        eventName={`${prefix}_google_continue`} redirectPath={redirectPath}
        trackingParams={{ ...trackingParams, cta_id: `${prefix}_google_${interval}` }} />}
    <div className="premium-signup-actions__links">
      {!registered && <AppLink href={`/app/signup?${signupParams}`} className="email-signup-link"
        data-analytics-event={`${prefix}_email_signup_${interval}_click`}
        data-analytics-cta-id={`${prefix}_email_${interval}`}
        data-analytics-cta-location={ctaLocation}
        data-analytics-account-type={landingAccountType(account)}
        data-analytics-offer-variant={`landing_${ctaLocation}`}
        data-analytics-auth-method="email" data-analytics-auth-target="signup"
        data-analytics-plan-intent={planIntent}
        data-analytics-billing-interval={interval}>{home.premiumEmail}</AppLink>}
      {compareHref && <a href={compareHref} className="premium-compare-link"
        data-analytics-event="hero_premium_compare_click" data-analytics-cta-id="hero_premium_compare"
        data-analytics-cta-location={ctaLocation}>{home.heroPremiumPlans} ↗</a>}
    </div>
  </div>;
}
